import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface Toast {
  id: number;
  message: string;
  type: ToastType;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private counter = 0;
  toasts = signal<Toast[]>([]);

  success(message: string, duration = 4000) { this.add(message, 'success', duration); }
  error(message: string, duration = 10000)  { this.add(message, 'error',   duration); }
  warning(message: string, duration = 5000) { this.add(message, 'warning', duration); }
  info(message: string, duration = 4000)    { this.add(message, 'info',    duration); }

  /**
   * Igual que error(), pero pensado para errores de HttpClient (AA-27): toma el mensaje del
   * body de la respuesta (o el fallback si no viene) y le agrega el X-Request-Id de la
   * respuesta cuando está presente, para que cualquiera pueda buscarlo en los logs del backend.
   */
  errorFromHttp(err: any, fallback: string, duration = 10000) {
    const message = err?.error?.message || fallback;
    const requestId = this.extractRequestId(err);
    this.add(requestId ? `${message} (ID: ${requestId})` : message, 'error', duration);
  }

  dismiss(id: number) {
    this.toasts.update(list => list.filter(t => t.id !== id));
  }

  private extractRequestId(err: any): string | null {
    return err?.headers?.get ? err.headers.get('X-Request-Id') : null;
  }

  private add(message: string, type: ToastType, duration: number) {
    const id = ++this.counter;
    this.toasts.update(list => [...list, { id, message, type }]);
    setTimeout(() => this.dismiss(id), duration);
  }
}
